export enum PapelUsuario {
  ADMIN = 'Admin',
  VISUALIZADOR = 'Visualizador',
  CLIENTE = 'Cliente'
}

export const PapelHelper = {
  ehAdmin: (papel?: string | null): boolean => papel === PapelUsuario.ADMIN,
  
  ehPDCA: (papel?: string | null): boolean => 
    papel === PapelUsuario.ADMIN || papel === PapelUsuario.VISUALIZADOR,
  
  ehCliente: (papel?: string | null): boolean => papel === PapelUsuario.CLIENTE,
  
  podeGerenciar: (papel?: string | null): boolean => papel === PapelUsuario.ADMIN,
  
  obterLabel: (papel?: string | null): string => {
    switch (papel) {
      case PapelUsuario.ADMIN:
        return 'Administrador'
      case PapelUsuario.VISUALIZADOR:
        return 'Visualizador PDCA'
      case PapelUsuario.CLIENTE:
        return 'Cliente'
      default:
        return 'Desconhecido'
    }
  }
}

export enum TabProjeto {
  DESENVOLVIMENTO = 'desenvolvimento',
  EMITIDOS = 'emitidos'
}

export const TabProjetoLabels: Record<TabProjeto, string> = {
  [TabProjeto.DESENVOLVIMENTO]: 'Projetos',
  [TabProjeto.EMITIDOS]: 'Emitidos'
}

export enum StatusConvite {
  PENDENTE = 'pendente',
  ACEITO = 'aceito',
  CANCELADO = 'cancelado',
  EXPIRADO = 'expirado',
  URGENTE = 'urgente'
}

export const StatusConviteLabels: Record<StatusConvite, string> = {
  [StatusConvite.PENDENTE]: 'Pendente',
  [StatusConvite.ACEITO]: 'Aceito',
  [StatusConvite.CANCELADO]: 'Cancelado',
  [StatusConvite.EXPIRADO]: 'Expirado',
  [StatusConvite.URGENTE]: 'Urgente'
}

export const StatusConviteCores: Record<StatusConvite, string> = {
  [StatusConvite.PENDENTE]: 'bg-yellow-100 text-yellow-800',
  [StatusConvite.ACEITO]: 'bg-green-100 text-green-800',
  [StatusConvite.CANCELADO]: 'bg-red-100 text-red-800',
  [StatusConvite.EXPIRADO]: 'bg-gray-100 text-gray-800',
  [StatusConvite.URGENTE]: 'bg-orange-100 text-orange-800'
}

export enum FormatoExportacao {
  CSV = 'csv',
  EXCEL = 'excel'
}

export enum OrdemClassificacao {
  ASC = 'asc',
  DESC = 'desc'
}

